<template>
    <div>
        <rkm-row>

            <rkm-col cols="2">
                <rkm-form-select
                    name="Turno"
                    :options="data.form.turnos"
                    label="Turno"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.atendimento.turnoId"
                    :validations="validations.turno"
                    default-option-text="Selecione"
                    value-field="id"
                    class="pt-0"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    name="Tipo de imóvel"
                    label="Tipo de imóvel"
                    :options="data.form.imovelTipo"
                    show-default-option
                    text-field="descricao"
                    v-model="data.model.atendimento.imovelTipoId"
                    :validations="validations.imovelTipo"
                    default-option-text="Selecione"
                    value-field="id"
                    class="pt-0"
                    @change="handleImoveltipo()"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    v-model="data.model.atendimento.latitude"
                    :validations="validations.latitude"
                    label="Latitude"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    v-model="data.model.atendimento.longitude"
                    :validations="validations.longitude"
                    label="Longitude"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    :label="false"
                    v-model="data.model.atendimento.visitaCompartilhada"
                    class="pt-0"
                >
                    Visita compartilhada com outro profissional
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>

//Enums
import tipoImovel from '@/enums/atencao-basica/cadastro-domiciliar/tipoImovel'
import tipoVisita from '@/enums/atencao-basica/visita-domiciliar/tipoVisita'
import outrosMotivo from '@/enums/atencao-basica/visita-domiciliar/outrosMotivo'

export default {
    computed: {
        validations() {

            return {
                turno: { required: true },
                imovelTipo: { required: true },
                latitude: { max: 10, min_value: -90, max_value: 90 },
                longitude: { max: 10, min_value: -180, max_value: 180 },
            }
        },
    },
    data: () => ({
        enums: {
            tipoImovel,
            tipoVisita,
            outrosMotivo,
        },
    }),
    methods: {
        handleImoveltipo() {

            const motivo = this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.COMERCIO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.TERRENO_BALDIO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.PONTO_ESTRATEGICO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.ESCOLA
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.CRECHE
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.ESTABELECIMENTO_RELIGIOSO
                || this.data.model.atendimento.imovelTipoId == this.enums.tipoImovel.CASAI

            if (motivo) {

                this.showConfirmation(
                    `Para o tipo do imóvel selecionado, apenas os motivos (Cadastramento / Atualização, Ação educativa,
                        Imóvel com foco, Ação mecânica, Tratamento focal, Convite para atividades coletivas /
                        campanha de saúde, Orientação / Prevenção e Outros) poderão ser marcados. Deseja continuar?`,
                    async () => this.resetMotivos(),
                    async () => this.data.model.atendimento.imovelTipoId = null
                )
            }
        },
        resetMotivos() {

            this.data.model.motivo.buscaAtiva = []
            this.data.model.motivo.acompanhamento = []
            this.data.model.motivo.tipoVisita = this.data.model.motivo.tipoVisita
                .filter(item => item !== this.enums.tipoVisita.VISITA_PERIODICA)
            this.data.model.motivo.outroMotivo = this.data.model.motivo.outroMotivo
                .filter(item => item !== this.enums.outrosMotivo.EGRESSO_DE_INTERNACAO)
            this.data.model.atendimento.peso = null
            this.data.model.atendimento.altura = null
            this.data.model.atendimento.afericaoPa = null
            this.data.model.atendimento.temperatura = null
            this.data.model.atendimento.glicemia = null
            this.data.model.atendimento.momentoColetaId = null
        }
    },
    props: {
        data: { type: Object, required: false },
    }
}
</script>